import approvals from '../modules/approvals/lang/en'
// Ready translated locale messages
export default {
  ...approvals,
  general: {
    adminPanel: 'Administration panel',
    configGeneral: 'General configuration',
    helpCenter: 'Help Center',
    userPanel: 'User panel',
    others: 'Otros',
    required: 'Data required',
    requestStatus: {
      created: 'Created',
      sent: 'Sent',
      in_review: 'In review',
      approved: 'Approved',
      rejected: 'Rejected'
    },
    settingDelete: 'Setting successfully removed',
    period: 'Period',
    copy: 'Copy',
    category: 'Category',
    concepts: 'Concepts',
    amountRequest: 'Advance Amount',
    requestBy: 'Requested by',
    validateRequest: 'Validate request',
    validateRequestPettyCash: 'Validate petty cash request',
    validateExpenses: 'Validate expenses',
    expenseReport: 'Expense report',
    vehicle: 'Vehicle',
    licensePlate: 'License plate',
    initialMileage: 'Initial mileage',
    litersOfGasoline: 'Liters of gasoline',
    finalLitersOfGasoline: 'Final liters of gasoline',
    finalMileage: 'Final mileage',
    orderNumber: 'Order number',
    home: 'Home',
    dashboard: 'Dashboard',
    userOptions: 'User Options',
    reportsOptions: 'Reports Options',
    reportsType: 'Accumulated expenses by category',
    companyOptions: 'Company Options',
    expenseOptions: 'Expense Options',
    users: 'Users',
    userApplication: 'Users of applications',
    application: 'Application',
    categories: 'Categories',
    areas: 'Areas',
    settings: 'Settings',
    validators: 'Validators',
    approver: 'Approver',
    companies: 'Companies',
    company: 'Company',
    restrictions: 'Restrictions',
    projects: 'Projects',
    branches: 'Branches',
    allBranches: 'All branches',
    roles: 'Roles',
    expenses: 'Expenses',
    expenseStatus: 'Expense status',
    expenseItems: 'Expense Items',
    workflow: 'Workflow',
    permissions: 'Permissions',
    substitutes: 'Substitutes',
    subscriptions: 'Subscriptions',
    history: 'History',
    notifications: 'Notifications',
    rejected: 'Rejected Expenses',
    approbed: 'Approved Expenses',
    validate: 'Validate Expenses',
    approbe: 'Approve Expenses',
    check: 'Approvals',
    keywords: 'Keywords',
    payable: 'Payable Expenses',
    advances: 'Advances',
    logout: 'Logout',
    edit: 'Edit',
    delete: 'Delete',
    activate: 'Activate',
    activeValidator: 'Active validator',
    inactiveValidator: 'Inactive validator',
    deactivate: 'Deactivate',
    cancel: 'Cancel',
    submit: 'Submit',
    save: 'Save',
    saveChanges: 'Save changes',
    reset: 'Reset',
    name: 'Name',
    user: 'User',
    startDate: 'Start date',
    endDate: 'End date',
    selectEndDate: 'Choose an end date',
    project: 'Project',
    projectSecond: 'Project second',
    supplier: 'Supplier',
    status: 'Status',
    description: 'Description',
    date: 'Date',
    country: 'Country',
    currency: 'Currency',
    exchangeRate: 'ER',
    subtotal: 'Subtotal',
    total: 'Total',
    totalAmountMXN: 'Total amount MXN',
    totalMXN: 'Total MXN',
    amount: 'Amount',
    amountMXN: 'Amount MXN',
    formaPago: 'Payment type',
    metodoPago: 'Payment method',
    folioRef: 'Folio / Reference Number',
    folioReference: 'Folio / Reference',
    comment: 'Comment',
    receiptType: 'Receipt type',
    expenseType: 'Expense type',
    email: 'E-mail',
    uuid: 'UUID',
    isRefund: 'Is refund?',
    actions: 'Actions',
    deleteElement: 'Delete element',
    activateElement: 'Activate element',
    deactivateElement: 'Deactivate element',
    deleteElementQuestion: 'Are you sure you want to delete this element?',
    activateElementQuestion: 'Are you sure you want to activate this element?',
    deactivateElementQuestion:
      'Are you sure you want to deactivate this element?',
    searchNotFound: 'Your search for {search} found no results.',
    close: 'Close',
    optional: 'Optional',
    add: 'Add',
    remove: 'Remove',
    plan: 'Plan',
    reports: 'Reports',
    report: 'Report',
    expense: 'Expense',
    discount: 'Discount',
    iva: 'IVA',
    totalExpenses: 'Total Expenses',
    search: 'Search',
    searchForClick: 'Search (press enter to perform the search)',
    yes: 'Yes',
    no: 'No',
    filter: 'Filter',
    filterBy: 'Filter by',
    satXmlDownload: 'Xml pending for download of the SAT',
    xmlDownload: 'XML Downloads',
    downloadAppDesktop: 'Download application desktop',
    chooseLanguage: 'Choose language',
    active: 'Active',
    inactive: 'Inactive',
    logo: 'Logotype',
    noResults: 'No results found',
    locale: 'en-en',
    downloadReport: 'Download report',
    taxes: 'Taxes',
    selectFilters: 'Select filters',
    image: 'image',
    employee: 'Employee',
    year: 'Year',
    month: 'Month',
    paid: 'Expenses completed',
    next: 'Next',
    pay: 'Pay',
    view: 'View',
    downloadXML: 'Download XML',
    optionalField: ' (Optional)',
    months: {
      jan: 'Jan',
      feb: 'Feb',
      mar: 'Mar',
      apr: 'Apr',
      may: 'May',
      jun: 'Jun',
      jul: 'Jul',
      aug: 'Aug',
      sep: 'Sep',
      oct: 'Oct',
      nov: 'Nov',
      dec: 'Dic'
    },
    seeMore: 'See more',
    back: 'Back',
    advance: 'Advance',
    totalAmountCheck: 'Total expense',
    advanceExpense: 'Advance expense',
    noHave: 'Not have',
    payment: 'Payment',
    refund: 'Refund',
    details: 'Details',
    withoutRestrictions: 'Without restrictions',
    contacts: 'Contacts',
    reason: 'Subject',
    message: 'Message',
    deleteContact: 'Delete Contact',
    expenseDate: 'Expense date',
    accept: 'Accept',
    createdBy: 'Created by',
    assigned: 'Assigned',
    all: 'All',
    default: 'Default',
    defaults: 'Default',
    incomplete: 'Incomplete',
    paymentsMade: 'Payments made',
    downloadExpensesFiles: 'Download expenses files',
    expensesFiles: 'Expenses Files',
    download: 'Download',
    availableFiles: 'Available files',
    transactionDate: 'Transaction Date',
    totalAmount: 'Total amount',
    availableAmount: 'Available amount',
    totalAmountPetty: 'Total amount in Petty Cash/AMEX Card',
    oneOptionRequired: 'You must select at least one option',
    validationError: 'There are errors in the data validation. <br/> Please, check the form again.',
    errorChargeDataByRangeDate: 'Try with a shorter date range',
    updateStartDate: 'The initial date range was updated',
    updateEndDate: 'The final date range was updated',
    nonAllowedCharacters: 'Non allowed characters',
    verifyEFOS: 'Verify EFOS',
    certifiedDate: 'Certified date',
    folio: 'Folio',
    warning: 'Warning',
    success: 'Success',
    searching: 'Searching',
    loading: 'Loading',
    print: 'Print',
    receipt: 'Receipt',
    receiptUniversal: 'Receipt expenses',
    searchNoMatch: 'No results match your search.',
    ruc: 'RUC',
    dv: 'DV',
    is_national: 'Is National?',
    myExpenses: 'Missing expenses',
    myExpensesNew: 'My expenses',
    collapse: 'Collapse',
    extend: 'Extend',
    cardNumber: 'AMEX card number',
    cardAbbr: 'AMEX card',
    cardNumberAbbr: 'AMEX card No.',
    conciliations: 'Conciliations',
    noDefined: 'No defined',
    loadingText: 'Loading... Please wait',
    noDataText: 'No data to show',
    previous: 'Previous',
    waitingMessage: 'Loading data, please wait...',
    type: 'Tipo',
    amountSpent: 'Amount spent',
    generalSearch: 'To look for: ',
    downloadFiles: 'Download files',
    undo: 'Undo',
    editSave: 'Edit and Save',
    editSend: 'Edit and Send',
    businessUnit: 'Business Unit',
    downloadLayout: 'Download layout',
    erpExportLog: 'Layout downloads',
    downloadLayoutByExpense:  'Download layout by expense',
    addExpenseIdLayout: 'Verification (Press enter if adding manually)',
    layoutList: 'Layout list',
    reportListId: 'Download report by list',
    erpExportLogOne: 'Layout download',
    generateLayoutBank: 'Banking layout',
    generateLayoutERP: 'ERP layout',
    generateLayoutHelperXml: 'XML Helper',
    payGenerateLayout: 'Pay and generate layout',
    Accountingid: 'Accounting id',
    Addbussinessunit: 'Add bussiness unit?',
    NextXml: 'Next xml',
    reasonForRejection: 'Reason For Rejection',
    okBlue: 'Blue voucher',
    checked: 'checked',
    toCheck: 'To Check',
    voucherAmount: 'Voucher amount',
    remainingAmount: 'Remaining amount',
    amountPettyCash: 'Amount in petty Cash',
    availableBox: 'Available in box',
    alls: 'All',
    missingReserveExpenses: 'Missing reserve expenses',
    with: 'with',
    commentFrom: 'Comment from',
    sessionExpired: 'Your session has expired',
    clean: 'Clean',
    create: 'Create',
    charge: 'Charge',
    multiProjects: 'Multi-projects',
    selectMultiProjects: 'select multiproyectos',
    errorResponseMultiple: 'Some data was not saved correctly, please verify and try again.',
    max30Data: 'You can only send a maximum of 30 records at a time.',
    amountMax: 'Maximum Amount',
    selectDates: 'Select dates',
    invalidCodes: 'Invalid codes',
    invalidCodesMessage: 'The following codes are invalid: {codes}. Please verify and try again.',
    pettyCashAmex: 'Petty Cash/AMEX Card',
    addAmountCorrect: 'Add correct amount',
    erroTimeout: 'Request timeout exceeded, please try again',
  },
  dataTable: {
    noResult: 'No records found',
    loadingRecords: 'Loading records'
  },
  address: {
    name: 'Address',
    street: 'Street',
    city: 'City',
    state: 'State',
    country: 'Country',
    zip: 'Zip Code'
  },
  taxFields: {
    taxId: 'Tax ID',
    phone: 'Phone',
    regime: 'Social regime',
    socialReason: 'Social reason'
  },
  categories: {
    name: 'Category',
    add: 'Add category',
    edit: 'Edit category',
    delete: 'Delete category',
    new: 'New category',
    description: 'Category name',
    setDefault: 'Select as default',
    loadDefault: 'Load Default Categories',
    confirmDefault:
      'Are you sure that you want to create the next default categories? you can modify or add more categories later',
    warning:
      'The company does not have a default category defined. To be able to upload correctly XML files in the system, select a category as default',
    ct: {
      fuel: 'Fuel',
      meals: 'Meals',
      hotel: 'Hotel',
      tollGates: 'Toll gates',
      transportation: 'Transportation',
      others: 'Others'
    },
    group: 'Group',
    analyticalAccount: 'Analytical account',
    analyticalDescription: 'Analytical description',
    accountingAccount: 'Accounting account',
    accountingDescription: 'Accounting description',
    AddanalyticalAccount: 'Add analytics account?'
  },
  travelTypes: {
    name: 'Travel type',
    nameView: 'Travel type expenses',
    add: 'Add',
    edit: 'Edit travel type',
    delete: 'Delete travel type',
    new: 'New travel type',
    description: 'travel type name',
    setDefault: 'Select as default',
    loadDefault: 'Load Default travel types',
    confirmDefault:
      'Are you sure that you want to create the next default travel types? you can modify or add more travel types later',
    warning:
      'The company does not have a default travel type defined. To be able to upload correctly XML files in the system, select a travel type as default'
  },
  expenses: {
    subtitle: 'Expense history',
    commentRequired: 'Comment is required',
    errorConcept: 'Need to add information in the concepts',
    errorCountConcept: 'Add at least one item in the expense',
    errorCountConceptLine: 'Fill in the description field in the concepts',
    errorCountConceptAmount: 'The amounts of the concepts must be greater than 0',
    errorCountConceptCategory: 'Be sure to select the categories in the concepts',
    name: 'Expense',
    add: 'Add report',
    create: 'Create expense',
    addFiscalExpense: 'Add Fiscal expense',
    addNoFiscalExpense: 'Add No Fiscal expense',
    edit: 'Edit expense',
    attach: 'Attach files',
    required_attachment: 'Attachment required',
    attachedFiles: 'Attached files',
    file: 'File',
    files: 'Files',
    noFiles: 'Does not have attached files',
    fileType: 'File type',
    delete: 'Delete expense',
    new: 'New expense',
    selectExpense: 'Select Expense',
    relateExpense: 'Relate Expense',
    description: 'Expense description',
    start: 'Start',
    startWorkflow: 'Start workflow',
    sendValidation: 'Send to validate',
    sendValidationMessage: 'Are you sure you want to submit for verification validation?',
    xmlPending: 'You have some XML that are pending to download from the SAT before that you can start the workflow',
    startWorkflowQuestion: 'Are you sure you want to start the workflow for the selected expense?',
    sendValidationMultiProject: 'They are making modifications to the projects. Check your expense allocations before submitting for validation.',
    selectedExpense: 'Select a check',
    view: 'View expense',
    viewMessage: 'Would you like to go to the expenses?',
    exs: {
      created: 'Created',
      sented: 'Sented',
      reviewed: 'Reviewed',
      payable: 'Payable',
      payment: 'Partial payment',
      paid: 'Completed',
      approved: 'Approved',
      complete: 'Completed',
      validator: 'Validator'
    },
    status: {
      created: 'Created',
      sented: 'Sented',
      reviewed: 'Reviewed',
      payable: 'Payable',
      payment: 'Partial payment',
      paid: 'Completed',
      complete: 'Completed',
      approved: 'Approved',
      rejected: 'Rejected'
    },
    statExpense: {
      new: 'New',
      rejected: 'Rejected'
    },
    history: {
      pending: 'Pending',
      sented: 'Sented by',
      reviewed: 'Reviewed by',
      payable: 'Approved by',
      paid: 'Paid by',
      assignedvalidator: 'Assigned validator',
      inRepresentationOf: 'In Representation Of'
    },
    toPettyCash: 'To Petty Cash/AMEX Card',
    pettyExpense: 'Petty Cash/AMEX Card expense',
    tracking: 'Expense tracking',
    downloadAccuse: 'Download accuse',
    progress: 'progress',
    amountMessage: 'The amount must be in the currency of the expense',
    tip: 'Tip',
    addTip: 'Add tip to expense',
    addWatchTip: 'Add/Watch tip',
    seeTip: 'See Tip',
    reservations: {
      users: 'Users',
      cashier: 'Representative',
      showRelations: 'Show relations',
      generateRelationship: 'Generate relationship',
      close: 'Close',
      tellerRelationship: 'Relationship of representatives',
      title: 'Reservations',
      add: 'Add reservation',
      simple: 'Booking checks',
      request: 'Reservation of requests'
    },
    relateToRequest: 'Do you want to relate to an expense request?',
    pendingExpenses:
      'You have {totalPending} pending Amex expenses to go up. You have a period of no more than 5 days to report',
    filterMessage:
      'You must filter from December 01, 2021 to the current date to see the corresponding expenses',
    type: 'Type of expense',
    amountOf: 'Amount of',
    filter: {
      startDate: 'Start date of verification',
      endDate: 'End date of verification'
    },
    toRelate: 'To relate',
    categoriesPending: 'Categories to relate',
    categoriesPendingMessage:
      'You have {pending} categories to relate to an expense, these will be indicated in the categories selector when you create a new expense',
    expenseCharged: 'Expense charged successfully, pending to reconcile',
    resetToReconcile: 'Reset to reconcile',
    confirmReset: 'Confirm reseting AMEX expense',
    resetQuestion:
      'Are you sure you wish reset to "To reconcile" the AMEX expense',
    transactionNumber: 'Transaction',
    reservationExpType: 'Expense by type of reserve',
    backCheckout: 'Back to checkout',
    attentionBackCheckout: 'Attention: The expenses of the voucher with number <b>{expenseId}</b> will be returned to the user <b>{userName}</b> inbox so that she can modify them and resubmit the voucher, do you want to continue?',
    returnedExpense: 'Returned expense',
    editPeriod: 'Edit period',
    noApproverDefault: 'Without Approver, contact your administrator',
    blueVoucher: {
      errorValidationAmount: 'The voucher amount is not sufficient.',
      warning: 'Remember to attach the blue voucher to the first expense registered.',
      amountNotComplyRules: 'The verified amount does not comply with the rules of the blue voucher.',
      errorFile: 'You must attach the blue voucher to the first expense to submit the verification.',
      errorWorkFlow: 'It is necessary to attach the voucher.',
      addAmount: 'Add voucher amount'
    },
    travelExpense: {
      title: 'Travel Expenses',
      errorValidationAmount: 'Does not comply with the travel amount',
      warning: 'Remember to attach the travel expense to the first recorded expense. You must complete the travel amount and not exceed the additional 10%',
      amountNotComplyRules: 'The verified amount does not comply with the viatico rules'
    },
    errorAmount: 'Does not meet the expense amount.',
    missingExpenses: {
      unloadedExpenses: 'Unloaded expenses',
      loadedWithoutVerification: 'Loaded without verification',
      loadedWithVerification: 'loaded with verification',
      Approved  : 'Approved',
    },
    idExpenseSearch: '# Expense (Press enter to search)',
  },
  projects: {
    status: {
      active: 'Active',
      inactive: 'Inactive'
    },
    stat: {
      active: '(Active)',
      inactive: '(Inactive)'
    }
  },
  expenseItems: {
    name: 'Expense',
    add: 'Add expense item',
    delete: 'Delete expense item',
    fiscal: 'Fiscal expense',
    manual: 'Manual expense',
    description: 'Expense item description',
    noFileUploaded: 'No image uploaded for the expense',
    title: 'Upload expenses',
    readItemProgress: 'Reading expense item {current} of {total}',
    watchFile: 'View file',
    blackList: 'Tax id issuer in black list:',
    downloadProcess: 'There is expenses in download process',
    verifyEFOMsg: 'Verified in list 69-B of the SAT (It is not EFO)',
    exchangeRate: 'ER',
    referenceNumber: 'Reference No.',
    voucherType: 'Type',
    deleteConcepts: 'Delete concepts',
    handleRowDoubleClick: 'Double click to see expenses'
  },
  userApplication: {
    name: 'User of Application',
    add: 'Add user of application',
    delete: 'Delete relationship of user with application',
    relationshipOfUser: 'Relationship of user',
    withApplication: 'with application'
  },
  validation: {
    required: 'Required field.',
    minNumberChars: 'Must be at least {number} characters.',
    minNumberChar: 'Must be at least {number} characters.',
    maxNumberChar: 'May not be greater than {number} characters.',
    maxNumberChars: 'May not be greater than {number} characters.',
    exactNumberChars: 'Must be {number} characters.',
    minNumberDigits: 'Must be at least {number}.',
    maxNumberDigits: 'May not be greater than {number}.',
    exactNumberDigits: 'Must be {number}.',
    invalidEmail: 'Must be a valid email address.',
    invalidDecimal: 'Must be a number.',
    noSpecialChars: 'The item must not have any special character',
    exchange: '4 digits and up to 6 decimal places allowed',
    pettyCashAdvance: '6 digits and up to 2 decimal places allowed',
    fiveDigits: 'Exactly 5 digits',
    invalidNumber: 'Invalid number',
    onlyLetters: 'The item must have only letters',
    noSpace: 'The item must be only one word',
    deleteUserQuestion:
      'Are you sure you want to delete the user <b>{name}</b> with email <b>{email}</b>?',
    deleteSubscriptionQuestion:
      'Are you sure you want to delete the subscription of <b>{company}</b>?',
    passwordsDoNotMatch: 'Passwords do not match',
    success: 'Success',
    error: 'Error',
    maxNumChars: 'The element must be no more than {number} characters'
  },
  user: {
    name: 'User',
    add: 'Add user',
    addBatch: 'Add users by batch',
    edit: 'Edit user',
    delete: 'Delete user',
    avatar: 'Avatar',
    gender: 'Gender',
    male: 'Male',
    female: 'Female',
    birthDate: 'Birth Date',
    activate: 'Activate',
    downloadTemplate: 'Download template',
    addConfirm: 'User Confirmation',
    addQuestion: 'You are about to add this user. Please, confirm the information before continue',
    employeeNumber: 'Employee number',
    policyAddress: 'Policy address',
    depositBank: 'Deposit bank',
    bankAccount: 'Bank account',
    RFC: 'RFC',
    Taxid: 'Tax ID',
    AddempBa: 'Add employee banking details?',
    costCenter: 'Cost center',
    subtitle: 'User Management'
  },
  approver: {
    name: 'Approver',
    assign: 'Assign approver',
    add: 'Add approver',
    select: 'Select Approver',
    selectUser: 'Select User',
    delete: 'Delete Approver',
    sure_remove: 'Are you sure you want to delete the current approver?',
    current: 'Current approver',
    duplicate: 'The selected user is currently assigned as approver',
    default: 'Choose default user',
    default_message: 'Do you want to choose the next default user?',
    deleteUserQuestion:
    'Are you sure to remove the approver <b>{name}</b>?'
  },
  area: {
    name: 'Area',
    add: 'Add area',
    edit: 'Edit area',
    delete: 'Delete area',
    description: 'Area description'
  },
  branch: {
    name: 'Branch',
    add: 'Add branch',
    company: 'Company',
    edit: 'Edit branch'
  },
  company: {
    name: 'Company',
    add: 'Add company',
    edit: 'Edit company'
  },
  login: {
    oldPass: 'Old password',
    newPass: 'New password',
    confirmPass: 'Confirm Password',
    password: 'Password',
    label: 'Login',
    recoverPassword: 'Recover password',
    forgotYourPasswordQuestion: 'Forgot your password?',
    signInExistingAccount: 'Sign in existing account',
    useTheFormBelow: 'Use the form below to recover it.',
    welcome: 'Welcome back,',
    signInToAccount: 'Please sign in to your account.',
    inspectructRef: 'Need to inspect transportation units? Check out Inspectruck.',
    portability: 'Portability',
    mobilePlatform: 'Mobile platform',
    availability: 'Availability 24/7',
    continuousImprovement: 'Continuous improvement',
    reportsAndStatistics: 'Reports and statistics',
    accompaniment: 'Accompaniment',
    StoringData: 'Storing data and invoices in the cloud',
  },
  permission: {
    name: 'Permission',
    add: 'Add permission',
    edit: 'Edit permission',
    delete: 'Delete permission',
    description: 'Permission description'
  },
  project: {
    name: 'Project',
    add: 'Add project',
    edit: 'Edit project',
    delete: 'Delete project',
    activate: 'Activate project',
    deactivate: 'Deactivate project'
  },
  restriction: {
    name: 'Restriction',
    add: 'Add restriction',
    edit: 'Edit restriction',
    delete: 'Delete restriction',
    type: 'Restriction type',
    warningQuestion: 'Is a warning?',
    warning: 'Warning',
    date: 'Select a date',
    requiredFile: 'Required Attachment',
    restrictionBy: 'Restriction by',
    rt: {
      amount: 'Amount',
      date: 'Date',
      paymentType: 'Payment type',
      currency: 'Currency',
      amountByDay: 'Amount by day',
      attachFile: 'Attach file',
      description: 'Keywords'
    }
  },
  role: {
    ADMIN: 'Admin',
    EMPLOYEE: 'Employee',
    name: 'Role',
    add: 'Add role',
    edit: 'Edit role',
    delete: 'Delete role',
    addPermission: 'Add permission to: {permission}',
    removePermission: 'Remove permission to: {permission}',
    noPermission: 'Not have permissions yet'
  },
  setting: {
    name: 'Setting',
    add: 'Add setting',
    edit: 'Edit setting',
    delete: 'Delete setting',
    type: 'Type setting',
    periodType: 'Period type',
    deadline: 'Day of deadline',
    selectPeriodType: 'Select the period Type',
    weekly: 'Select the day of the week of your deadline',
    biweekly: 'Select the day of deadline of the first fortnight of the month',
    monthly: 'Select the day of deadline of the month',
    requiredComment: 'Required Comment',
    value: 'Value',
    days: 'Extension days',
    selectCurrencyType: 'Select currency type',
    selectCountryType: 'Select country type',
    CurrencyType: 'Currency type',
    CountryType: 'Country type',
    st: {
      period: 'Period',
      expenseComment: 'Expense comment',
      dateExtension: 'Date extension',
      currency: 'Currency',
      country: 'Country'
    },
    pt: {
      weekly: 'Weekly',
      biweekly: 'Biweekly',
      monthly: 'Monthly'
    }
  },
  validator: {
    name: 'Validator',
    assign: 'Assign validator',
    edit: 'Edit validator',
    delete: 'Delete validator',
    selectEmployee: 'Select employee',
    selectArea: 'Select area',
    date: 'Date of validation'
  },
  workflow: {
    name: 'Workflow',
    step: 'Step',
    addApprover: 'Add approver to flow',
    addValidator: 'Add validator',
    addValidatorIn: 'Add validator in: {area}',
    add: 'Add workflow',
    substitute: 'Substitute',
    element: 'Create element',
    description: 'Workflow description',
    changePlace: 'Change place',
    replaceValidator: 'Select the validator who wants to replace',
    workflowPosition: 'Workflow position',
    noSubstitute: 'Not have',
    workflowName: 'Flow process name',
    existConfirm:
      'This validator already exist in some point of this workflow, Are you sure you want to continue?',
    validatorExist:
      'This validator already exist in some point of this workflow'
  },
  substitutes: {
    name: 'Substitute',
    add: 'Add substitute',
    assign: 'Assign substitute'
  },
  dropzone: {
    default: 'Drag and drop files here to upload.<br> Max {size}{unit}',
    defaultMaxFiles: 'Drag and drop maximum {amount} files here to upload them.<br> Maximum {size}{unit}',
    fallback:
      'The browser is incompatible, the simple file upload will be used',
    fileTooBig:
      'File too big, the file size is {{filesize}} and the limit is {{maxFilesize}}',
    invalidFileType: 'Invalid file type',
    responseError:
      'An error ocurred processing the file upload, code: {{statusCode}}',
    cancelUpload: 'Cancel upload',
    uploadCanceled: 'Upload cancelled',
    cancelUploadConfirmation: 'Do you want to cancel the file upload?',
    removeFile: 'Remove file',
    removeFileConfirmation: 'Do you want to remove the file',
    maxFilesExceeded: 'Limit of number of files exceeded',
    limitedFiles: 'The file {{nameFile}} will not be added to the request because it exceeds the maximum number of files per request',
    textFileXml: 'Drag and drop files xml here to upload.<br> Max {size}{unit}',
    uploadUserBatch:
      'Drag and drop or click here to upload the user batch template.<br>  Max {size}{unit}',
    uploadAMEXBatch:
      'Drag and drop or click here to upload the AMEX espenses batch template.<br>  Max {size}{unit}'
  },
  subscriptions: {
    name: 'Subscriptions',
    application: 'Application',
    expiration_date: 'Expiration date',
    add: 'Add subscription',
    edit: 'Edit subscription',
    expirationDate: 'Expiration Date',
    delete: 'Delete subscription',
    vigent: 'Vigent',
    expired: 'Expired',
    toExpire: 'To expire',
    renovations: 'Renovations'
  },
  history: {
    name: 'My History',
    selectDate: 'Select date range',
    noItem: 'Not have any Item',
    local: 'en-en',
    allCategories: 'All categories',
    perCategorie: 'Category',
    allProjects: 'All projects',
    perProject: 'Project',
    allStatus: 'All status',
    perStatus: 'Status'
  },
  employerReports: {
    name: 'Employer Reports',
    startDate: 'Select start date',
    endDate: 'Select end date',
    filters: [
      {
        label: 'Rango de Fecha',
        value: 'date'
      },
      {
        label: 'Area',
        value: 'area'
      },
      {
        label: 'Oficina',
        value: 'office'
      },
      {
        label: 'Sucursal',
        value: 'branch'
      },
      {
        label: 'Proyecto',
        value: 'project'
      }
    ]
  },
  reportsType: {
    name: 'Accumulated expenses by category',
    description: 'Get total spending amounts grouped by categories, and filtered by specific users.',
    selectDate: 'Select date range',
    local: 'en-en',
    concepts: 'Concepts',
    category: 'Category',
    subtotal: 'Subtotal',
    descount: 'Discount',
    iva: 'IVA',
    total: 'Total',
    currency: 'Currency',
    resetForm: 'Reset form'
  },
  notifications: {
    name: 'Notification',
    all: 'All notifications',
    title: 'Title',
    message: 'Message',
    messages: 'Messages',
    status: 'Status',
    application: 'Application',
    notificationType: 'Notification type',
    markAsRead: 'Mark as read',
    read: 'Read',
    pending: 'Pending',
    youHave: 'You have',
    unreadMessages: 'unread messages.',
    date: 'Date',
    time: 'Time',
    delete: 'Delete Notification',
    confirmDelete: 'Are you sure you want to delete this notification?',
    Module: 'Module'
  },
  expensesApproved: {
    name: 'Approved expenses',
    single: 'Approved expense'
  },
  expenseDetailEmployee: {
    nameEmployee: 'Employee Report',
    nameEmployees: 'Detailed expenses by employee',
    downloadUserSummary: 'Download user summary',
    nameDetailEmployee: 'Employee Detailed Report',
    nameDetailEmployees: 'Detailed expenses by employee',
    myDetailReport: 'My detailed report',
    description: 'Obtain specific data to know the expenses that each user has issued, this report allows you to filter by open dates.',
    download: 'Download Report',
    employee: 'Employee',
    perEmployee: 'Employee',
    perCategorie: 'Categorie',
    perStatus: 'status',
    perDate: 'Date',
    perArea: 'Area',
    perProject: 'Project',
    allEmployees: 'All Employees',
    allCategories: 'All Categories',
    allStatus: 'All Status',
    allDates: 'All Dates',
    allAreas: 'All Areas',
    allProjects: 'All Projects',
    detail: 'With detail',
    noDetail: 'Without detail',
    noResults: 'No results found',
    dateError: 'Start date cannot be greater than end date',
    headers: {
      itemId: 'Item ID',
      category: 'Category',
      description: 'Description',
      country: 'Country',
      uuid: 'UUID',
      subtotal: 'Subtotal',
      total: 'Total',
      currency: 'Currency',
      exchange: 'Exchange rate',
      grandTotal: 'Grand total',
      employee: 'Employee',
      status: 'Status'
    }
  },
  workflowValidation: {
    add: 'Add items in to the expense',
    reject: 'Expense item rejected',
    approb: 'Expenses approved',
    commentV: 'Comments',
    expense: 'Expenses No. ',
    expenseNo: 'Expense No.',
    item: 'Expenses Item No. ',
    typeItem: 'Type',
    viewItem: 'View and Edit expenses',
    selectItems: 'Select the elements that you want to put it in the Expense',
    comment: 'View Comment',
    dateExpense: 'Date expenses:',
    approbad: 'Approved',
    valid: 'Validate',
    rejec: 'Reject',
    confirmR: 'Confirmation of expense to be rejected',
    rechazE: 'You will reject the expense No. ',
    confirmRejectMultiple: 'Confirmation of expenses to be rejected',
    rejectedAboutExpense: 'You will reject the expenses No. ',
    descriptionE: 'Describe why are you rejecting this expense',
    confirmAp: 'Confirmation of approved check',
    confirmValid: 'Confirmation of validate check',
    approbE: 'Are you sure you want approve the check No. ',
    validE: 'Are you sure you want to validate the check No.',
    appro: 'Approved Expenses',
    nameUser: 'Username: ',
    areaW: 'Area: ',
    categoryW: 'Category: ',
    typeReceipt: 'Expenses type: ',
    listExpenses: 'List of expenses of the check No. ',
    viewExpensesItems: 'View expenses items',
    showImage: 'Show image',
    hideImage: 'Hide image',
    changeImage: 'Change File',
    addOptionalComment: 'Add optional comment',
    validatorComments: 'Validator comments',
    abbrExpenseNo: 'Exp. No.',
    addPendingExpenses:'Add pending expenses'
  },
  annualExpensesReport: {
    name: 'Annual expenses by category',
    year: 'Year',
    description: 'Obtain total amounts of expenses that were completed within a year, organized by month and category.'
  },
  reports: {
    reportAnnualExpensesBranch: 'Annual expenses per branch',
    reportAnnualExpensesBranchDesc: 'Obtain total expense amounts that were completed over the course of a year, organized by month and branch.',
    reportExpensesCategoryBranch: 'Expenses by category and branches',
    reportExpensesCategoryBranchDesc: 'Get total expense amounts by categories and branches'
  },
  profiles: {
    companyProfile: 'Company profile',
    companyName: 'Company name',
    planInfo: 'Plan Information',
    lang: 'Language',
    deadline: 'Deadline',
    minUsers: 'Min Users',
    maxUsers: 'Max Users',
    userProfile: 'User Profile',
    userInfo: 'User Information',
    changeAvatar: 'Change profile avatar',
    changeLogo: 'Change company logo',
    changePassword: 'Change password',
    male: 'Male',
    female: 'Female'
  },
  reportsByConcept: {
    name: 'Detailed expenses by category',
    description: 'Get the list of detailed user expenses filtered by categories.',
    id: 'ID',
    date: 'Date',
    state: 'Expense Status',
    UUID: 'UUID',
    expenseC: 'Expense Concept',
    category: 'Category',
    subtotal: 'Subtotal',
    taxes: 'Taxes',
    originalT: 'Original Total',
    currency: 'Currency',
    exchange_rate: 'Exchange Rate',
    total: 'Total',
    madeExpense: 'Employee',
    area: 'Area',
    local: 'en-en'
  },
  keywords: {
    add: 'Add keywords',
    addOne: 'Add keyword',
    edit: 'Edit keyword',
    delete: 'Deleting keyword',
    keyword: 'Keyword',
    empty: 'There are no keywords yet',
    exists: 'The keyword already exists',
    keywordEs: 'Keyword in Spanish',
    keywordEn: 'Keyword in English',
    insertionLang: 'Insertion language',
    Es: 'Spanish',
    En: 'English'
  },
  reportComparative: {
    name: 'Comparative of expenses',
    description: 'It allows you to compare and obtain amounts on expenses taking into account monthly and quarterly periods.',
    rangeOne: 'Range One',
    rangeTwo: 'Range Two',
    type: 'Comparative type',
    usersCategories: 'Users-Categories',
    periodType: 'Period type',
    quarter: 'Quarter',
    firstDate: 'First date',
    secondDate: 'Second date',
    firstQuarter: '1st Quarter (Jan - Mar)',
    secondQuarter: '2nd Quarter (Apr - Jun)',
    thirdQuarter: '3rd Quarter (Jul - Sep)',
    fourthQuarter: '4th Quarter (Oct - Dic)',
    differenceAmount: 'Difference (amount)',
    differencePercentage: 'Difference Expense (%)',
    selectQuarter: 'Select the Quarter',
  },
  reportExpenseTracking: {
    name: 'Expense tracking',
    seeExpense: 'See expense',
    description: 'It allows you to track user expenses in detail to see the current status, in addition to seeing the lines charged by expense.'
  },
  ExpensesPayable: {
    name: 'Payable Expenses',
    paymentAmount: 'Payment amount',
    selectAmount: 'Select the amount that want to pay to this expense',
    remaining: 'Remaining',
    amountToPay: 'Amount to pay',
    paid: 'Finalize',
    confirmPayment: 'Are you sure you want to mark to "completed" the expense No.',
    myFlows: 'My flows',
    otherFlows: 'Other Flows',
    myApprovals: ' My approvals',
    descriptionPayMultipleExpense: 'You will proceed to pay for the selected checks and download the layout',
    payExpenses: 'Pay all checks?'
  },
  annualExpensesByEmployedReport: {
    name: 'Annual expenses by employee',
    description: 'Obtain total amounts of expenses by users considering the period of one year (current year), the amounts are grouped by month.'
  },
  ExpensesPaid: {
    name: 'Expenses completed'
  },
  settings: {
    weekDays: {
      sunday: 'Sunday',
      monday: 'Monday',
      tuesday: 'Tuesday',
      wednesday: 'Wednesday',
      thursday: 'Thursday',
      friday: 'Friday',
      saturday: 'Saturday'
    }
  },
  wizard: {
    period: {
      title: 'Configuration period',
      text:
        'In this screen set up the period. “Add setting”'
    }
  },
  dashboard: {
    loaded: 'Loaded expenses',
    amount: 'Expenses amount',
    amountByType: 'Approved expense amount by type',
    paidByType: 'Completed expense amount by type',
    amountApproved: 'Approved expense amount',
    amountPaid: 'Completed expense amount',
    approvedType: 'Approved expense type',
    paidType: 'Completed expense type',
    expenseByProject: 'Completed expenses by project',
    expenses: 'Expenses',
    quart: 'this Quarter',
    month: 'this Month',
    year: 'this Year',
    quarter: 'Quarterly',
    monthly: 'Monthly',
    yearly: 'Yearly',
    projectsPerPage: 'Projects per page'
  },
  pettyCash: {
    title: 'Petty Cash',
    subtitle: 'Own petty cash management',
    add: 'Make advance movement',
    addPayment: 'Add payment',
    edit: 'Edit petty cash',
    removeCash: 'Remove advance',
    removePetty: 'Remove advance',
    removeQuestion:
      'Are you sure that you want to remove the advance of this user?',
    history: 'History of advances',
    currentAmount: 'Current amount',
    income: 'Incomes',
    expense: 'Expenses',
    payment: 'Payment',
    withdraw: 'Withdraw',
    downloadHistory: 'Download History',
    downloadRequests: 'Download Requests',
    makeMovement: 'Make movement',
    movementType: 'Movement Type',
    cardNumber: 'Card No.',
    transactionDate: 'Date',
    vendor: 'Vendor Name',
    transactionNumber: 'Transaction No.',
    description: 'Description',
    amount: 'Amount',
    type: 'Type',
    expenseType: 'Expense AMEX',
    creditType: 'Credit to Petty Cash/AMEX Card',
    continue: 'Continuar',
    select: 'Select the items to import',
    cardNumberEmpty: 'No AMEX card number',
    importAMEX: 'Import AMEX data',
    pettyCash: 'petty cash',
    amexCard: 'AMEX card',
    balanceIn: 'Balance In',
    amexCardMessage: 'Corporate Card: Active',
    requestPettyCash: 'Request Petty Cash',
    requestPettyCashEdit: 'Edit Petty Cash Request',
    requestPettyCashRemove: 'Delete petty cash request',
    requestPettyCashRemoveQuestion:
      'Are you sure that you want to delete this petty cash request?',
    requestPettyCashReject: 'Reject petty cash request',
    requestPettyCashRejectQuestion:
      'To reject the request {folio} you need to enter the reason for the rejection.',
    requestPettyCashRejected: 'Rejected request',
    rejectReason: 'Reason for rejection',
    reject: 'Reject',
    requestPettyCashTracking: 'Request tracking',
    requestPettyCashValidate: 'Validate petty cash request',
    requestPettyCashValidateQuestion:
      'Are you sure that you want to validate this petty cash request?',
    requestPettyCashValidationQuestion:
      'Are you sure that you want to send this petty cash request to validation?',
    progress: {
      created: 'Created',
      sented: 'Sent',
      reviewed: 'Reviewed',
      approved: 'Approved',
      deposited: 'Credited to petty cash'
    }
  },
  amexCard: {
    title: 'AMEX card',
    edit: 'Edit AMEX card',
  },
  verifyEFOS: {
    check: 'check blacklist',
    start: 'Verify CFDIS',
    searchByTax: 'Search Tax ID',
    searchInfo:
      'You can search if the Tax ID belongs to the SAT blacklist ',
    verifyCFDIS: 'Check if your CFDIs have been sended by an EFOS',
    set: 'Set',
    taxSuccess:
      'The Tax ID of the issuer {taxID} is not on the EFOS List of the SAT',
    taxWarning:
      'The Tax ID of the issuer {taxID} is on the EFOS List of the SAT',
    noData: 'No issuer invoices were found in the list of EFOS',
    hasData: 'Issuer invoices were found in the list of EFOS',
    subheader:
      'Identify those companies or taxpayers recognized by the SAT that make simulated invoices (purchase of invoices or traffic of CFDI vouchers)'
  },
  conciliation: {
    titleToReconcile: 'Expenses to reconcile',
    titleReconciled: 'Reconciled expenses',
    titleExcluded: 'Excluded expenses',
    titleMissing: 'Missing expenses',
    status: {
      toConciliate: 'To conciliate',
      conciliated: 'Conciliated',
      excluded: 'Excluded',
      missing: 'Missing'
    },
    statusLabel: 'Status',
    accountNo: 'Account number',
    amexExpenseNo: '# AMEX',
    BluExpenseNo: '# Bluespend',
    conciliedExpense: 'Concilied',
    conciliedDate: 'Concilied date',
    expenseDate: 'Expense date',
    download: 'Download',
    expenseNo: 'AMEX No.',
    date: 'Date',
    transactionNo: 'Transaction No.',
    description: 'Description',
    beneficiary: 'Beneficiary',
    amount: 'Amount',
    result: 'Result',
    foundMessage: 'The following matching records were found',
    searchAgain: 'Search Again',
    uuid: 'UUID',
    conciliateExpense: 'Conciliate expense',
    excludeExpense: 'Exclude expense',
    conciliate: 'Conciliate',
    exclude: 'Exclude',
    excludeAMEX: 'Exclude AMEX expense',
    found: 'Found',
    notFound: 'Not found',
    searchType: 'Search type',
    conciliateQuestion: 'Are you sure you want to conciliate this expense?',
    excludeQuestion: 'Are you sure you want to exclude this expense?',
    cardQ: 'Do you have an AMEX corporate card?',
    filter: {
      all: 'All expenses',
      advances: 'Advances',
      reconciledExpenses: 'Reconciled expenses',
      missingExpenses: 'Missing expenses',
      pettyCashAllExpenses: 'Petty Cash/All Expenses'
    },
    excludeBy: 'Exclude by',
    user: 'User',
    period: 'Period',
    tCAmount: 'TC Amount',
    bluespendReconciledAmount: 'Bluespend reconciled amount',
    missingAmount: 'Missing amount',
    excludedAmount: 'Excluded amount',
    notConciliated: 'Unconciliated',
    tcExpenses: 'TC Expenses',
    confirmAMountExpenseCharged: 'Confirm amount of expense to be charged',
    questionCpmfirmCharge:
      'Are you sure to charge the expense with an amount of {amountItem}?',
    sinceAmexAmount: 'since the AMEX amount is {amountAmex}'
  },
  viatics: {
    downloadExcelReport: 'Download excel report',
    validateExtension: 'Validate extension',
    rejectExtension: 'Reject extension',
    vehicleQuestion: 'Do you need a vehicle?',
    addExtras: 'Add magnification',
    saveExtras: 'Save magnification',
    addCategorie: 'Add categorie',
    numberPeople: '# people',
    abbrNumberPeople: '# people',
    dateStart: 'Date start',
    dateEnd: 'Date end',
    actions: 'Actions',
    addComment: 'Add comment',
    addDescription: 'Add description',
    advanceQuestion: 'Require advance?',
    advanceAuthorized: 'Advance',
    amountAuthorized: 'Amount authorized',
    approber: 'Approver',
    approberComment: 'Comment',
    approberDate: 'Date',
    approxPrice: 'Price',
    approxQuantity: 'Quantity',
    quantity: 'Quantity',
    abbrQuantity: 'Qty.',
    category: 'Select category(s)',
    categoryHeader: 'Category',
    commentMessage: 'Click if you want to add a comment',
    confirmSendTitle: 'Confirmation of send to validate request',
    confirmTitle: 'Confirmation of approbe this request',
    delete: 'Delete',
    deleteQuestion: 'Are you sure you want to delete the request with folio',
    deleteRequest: 'Delete request',
    deleteTitle: 'Confirmation of delete request',
    descriptionMessage: 'Click if you want to add a description',
    destination: 'Destination City',
    details: 'See details',
    downloadRequest: 'Download Request',
    edit: 'Edit request',
    folio: 'Folio',
    from: 'From',
    generalData: 'General data',
    new: 'New request',
    newRequest: 'Generate New request',
    origin: 'Origin City',
    place: 'Place',
    position: 'Position',
    requestDate: 'Request date',
    saveAndSend: 'Save and Send',
    send: 'Send to validate',
    sendQuestion:
      'Are you sure you want to save and send to validate the request with folio',
    status: {
      toValidate: 'To validate',
      inValidation: 'In validation',
      validated: 'Validated',
      approbed: 'Approbed',
      rejected: 'Rejected',
      created: 'Created'
    },
    title: 'Expenses Request',
    travelPeriod: 'Select the period',
    travelQuestion: 'Is a travel expense?',
    travelType: 'Select the travel type',
    to: 'To',
    type: 'Type',
    reject: 'Reject request',
    rejectTitle: 'Confirmation of reject request',
    rejectQuestion:
      'To reject the request {folio} you need to enter the reason for the rejection.',
    requestedBy: 'Requested by',
    requestDetails: 'Request details',
    requester: 'Requester',
    reasonRejected: 'Reason for rejection',
    user: 'Requested by',
    validate: 'Validate request',
    validateQuestion:
      'Are you sure you want to validate the request with folio',
    validationMessage: 'Validation data',
    validationDescription: 'If you want you can add a validation message',
    validators: 'Select validator',
    assignedTo: 'Assigned user',
    totalAmountAdvance: 'Total amount of advance',
    warningAddExtension: 'No more extensions can be created, the check is in validation status.',
    extension: 'Extension',
    validationExtensionAlert: 'An extension is in the process of being validated.',
    validationCategoryRequiredAlert: 'You must add at least one category.',
    validationExtensionRequiredAlert: 'You must add at least one category to the extension.',
    copyExpense: 'Copy request',
    confirmCopyExpense: 'Are you sure you want to copy the application?'
  },
  helpDrawer: {
    NotificationsPage: {
      title: 'Notifications Page',
      text:
        'It allows to communicate messages in real time, which are generated by the system, based on the expense process.'
    },
    DashboardPage: {
      title: 'Dashboard Page',
      text:
        '<li>Expenses charged: Indicates the total expenses charged regardless of the status.</li><li>Amount of expenses: Reflects the total amount in pesos, with respect to the expenses charged.</li><li>Expenses completed: Shows the total expenses that have already been completed.</li><li>Rejected Expenses: Shows the total expenses that were rejected.</li><li>Amount of expenses approved by type: Indicates the total expenses separated by categories.</li><li>Amount of expenses completed: It reflects how many expenses were completed in each month (according to the filter that is consulted, monthly, quarterly or annually).</li><li>Type of expenses completed: Indicates how many expenses were completed by category, expressed in a hoop diagram, which reflects the total expenses and the percentage paid for that category.</li><li>Expenses per project: It reflects the total expenses that were completed per project, in the graph it reflects the amounts per project, and the month that they were completed.</li>'
    },
    contactPage: {
      title: 'Contact Page',
      text:
        'It shows data about potential clients, who are interested in knowing the system and being contacted immediately.'
    },
    UsersPage: {
      title: 'Users Page',
      text:
        '<li>Add user: Generate new users Administrators and employees. </li> </br> <li> Add users by batch: Download the template in XLS format, fill in the corresponding data and attach in the view of the system, for batch loading of users. </li> '
    },
    ValidatorsPage: {
      title: 'Validators Page',
      text:
        '<li>It generates the validators that can be used in the flow processes, for the different areas to be used.</li>'
    },
    ValidateRequest: {
      title: 'Validate Request Page',
      text: '<li>Validate request: Allows you to validate expense requests that are in the validation process. You can approve or reject the request, as well as add comments for the requester.</li>'
    },
    ValidateRequestPettyCash: {
      title: 'Validate Petty Cash Request Page',
      text: '<li>TO VALIDATE: Shows the petty cash requests assigned to you for review. You can check the tracking of each request, validate it or reject it stating the corresponding reason.</li></br><li>TO APPROVE: Shows the petty cash requests that have already been validated and are waiting for final approval, from here you can approve or reject them.</li>'
    },
    missingReserveExpenses: {
      title: 'Missing Reserve Expenses Page',
      text: '<li>Allows you to view and follow up on expenses that have not yet been reconciled against assigned reserves, making it easier to identify pending items and manage their reconciliation on time.</li>'
    },
    representativesPage: {
      title: 'Representatives Page',
      text: '<li>Allows you to manage registered representatives, as well as query, download reports, and delete records as required for company control.</li>'
    },
    TravelTypesPage: {
      title: 'Travel Types Page',
      text: '<li>Allows you to manage the travel types used in the company, including adding, editing, deleting, and setting a default travel type. It also offers the option to load a set of default travel types, which are required for the proper processing of travel expenses.</li>'
    },
    substitutesPage: {
      title: 'Substitutes Page',
      text:
        '<li>Add substitute: By adding substitute, it allows users to be prepared for their possible selection to replace a validator, in certain flow processes. </li>'
    },
    ApproverPage: {
      title: 'Approver Page',
      text:
        '<li>User responsible for approving expenses and making the corresponding payments, there should only be a single approver for the company.</li>'
    },
    CompaniesPage: {
      title: 'Companies Page',
      text:
        'It shows companies that are subscribed to the platform, indicating their respective data.'
    },
    SubscriptionsPage: {
      title: 'Subscriptions Page',
      text:
        'It allows the relationship between the company and the requested subscription to be generated, with this action the user will have access to the platform until the established expiration date.'
    },
    AreasPage: {
      title: 'Areas Page',
      text:
        'Register the areas that are required for your company, with this you can keep a more detailed control of expenses.'
    },
    BranchesPage: {
      title: 'Branches Page',
      text:
        'Enter the branches that your company has, at the different points, registering the data you request.'
    },
    ProjectsPage: {
      title: 'Projects Page',
      text:
        'Enter the projects you may require to report expenses. The projects refer to specific groups or teams, this in order to keep an optimal control of spending. </br> </br> <li> ACTIVE: It allows showing the list of projects that are active, this allows to be selected when generating expenses. </li> </br> <li> INACTIVE: It allows viewing those projects that were deactivated, and are not shown for the selection of expenses, in case they are required again, you have the option of be activated. </li> '
    },
    CategoriesPage: {
      title: 'Categories Page',
      text:
        'The categories are classifications belonging to the expenses, the system provides a set of categories that you can use, independent of it, you can generate more categories for your company.'
    },
    RestrictionsPage: {
      title: 'Restrictions Page',
      text:
        'It allows to establish restrictions that indicate to the user certain measures to consider when their expenses rise and with it take control of the company, the restrictions may apply by area or project, the types of restrictions are provided by the system.'
    },
    WorkflowPage: {
      title: 'Workflow Page',
      text:
        'The configuration of the workflow is totally required to be able to carry out the expense validation flow. Various workflows can be configured for different areas, taking into account registered validators for existing areas. </br> </br> <li> In the flow, you can configure the steps you consider appropriate, for the respective validation, as well have the option to leave a substitute in process configured. </li> </br> <li> Change location: it could change the process of flow of the area, example, if user X was added first and then user Y, you can set the validator to be user Y in the foreground. </li> '
    },
    Keywords: {
      title: 'Keywords Page',
      text:
        'The configuration of keywords allows to easily identify to which category the loaded CFDI belong, therefore the wider the keywords are made, the easier it is to categorize it.'
    },
    ExpensesPage: {
      title: 'Expenses Page',
      text:
        'It allows you to generate checks and carry the optimal flow of states in your spending. </br> </br> <li> CREATED: It allows you to generate checks with their respective items, both CFDI (XML) or by RECEIPTS, after that You can send your expenses to start the validation process. </li> </br> <li> SENT: It allows you to show your own expenses prior to shipment, likewise you have the option to download ACUSE for each check, in order to have information about all the items you have sent. </li> </br> <li> REVISED: It shows the list of expenses that were reviewed while in the validation and approval process. </li> </br> <li> PAYABLE: Shows the list of expenses that are waiting to be paid. </li> </br> <li> PARTIAL PAYMENT: Those expenses that have partial payments (incomplete payments) are reflected. </li> </br> <li> COMPLETED: Shows the list of expenses that were fully paid (The expenses paid are made externally to the system). </li> '
    },
    pettyCashPage: {
      title: 'Generate petty cash page',
      text: 'Generate petty cash boxes, specifying the established amount and the user to whom each box belongs.'
    },
    requestPettyCashPage: {
      title: 'Petty Cash Request Page',
      text:
        'Allows you to request funds from your petty cash and follow up on each request. The amount available in your petty cash is shown at the top.</br></br><li>CREATED: Shows the requests you have generated and not sent yet. From here you can send them for validation, edit or delete them.</li></br><li>SENT: Shows the requests that are already in the validation and approval process.</li></br><li>COMPLETED: Shows the requests that have already been approved and paid.</li></br><li>Tracking: Available in any status, it shows the progress of the request (created, sent, reviewed and approved). If a request was rejected it is marked with a red flag showing the rejection reason.</li>'
    },
    amexCardPage: {
      title: 'AMEX Card Page',
      text: 'Register the AMEX corporate cards that will be used by your employees.'
    },
    advancesPage: {
      title: 'Advances Page',
      text:
        'It generates checks with advances established for specific users, in this way said user will report his expenses considering the advance and the project to which it is directed.'
    },
    expensesValidatePage: {
      title: 'Validate Expenses Page',
      text:
        '<li>VALIDATE EXPENSES: Carries out the validation process of expenses assigned to it. For this review you can consult in detail the expense data, amounts spent, attachments, you can even reject the item in case it does not comply with the guidelines of your company. </li> </br> <li> APPROVE EXPENSES: Approve the expenses that you have established, considering the revisions and pertinent criteria for its approval, you can consult in detail the expense data, amounts spent, attachments, you can even reject the item, for possible correction. </li> '
    },
    expensesRejectedPage: {
      title: 'Expenses Rejected Page',
      text:
        'It shows all your expenses that the validator has rejected for reasons that he has considered, you can also reset your rejected item and send it again for your next review.'
    },
    ExpensesApprovedPage: {
      title: 'Approved Expenses Page',
      text:
        'It shows the list of expenses that have been generated and that have been approved successfully.'
    },
    expensesPayablePage: {
      title: 'Payable expenses Page',
      text:
        'Perform the payment process completely or incompletely, for each of the expenses of your employees (The payment process is not linked in another system).'
    },
    expensesPaidPage: {
      title: 'Expenses completed Page',
      text:
        'Shows the list of expenses that were completed, this allows showing all users with their specific expenses that were covered in full payment.'
    },
    historyPage: {
      title: 'History Page',
      text:
        'Review all your expenses from shipped to completed, this allows you to be fully informed of all your personal expenses that you have generated, you can also filter from the current date to the previous one, and with details of each expense.'
    },
    ExpenseDetailEmployee: {
      title: 'Detailed expenses by employee Page',
      text: 'It allows you to obtain the expense report of the employees of your company, this report applies in detail showing the expenses of each employee, in the same way if you wish you can apply the filtering based on specific data that you require. (download of report in XLS format and attached files containing expenses apply).'
    },
    MyExpenseDetail: {
      title: 'My Detailed Report Page',
      text:
        'It allows you to review the detail of your own expenses; the query is always made for the user you are logged in with.</br></br><li>Filters: You can narrow down the information by status, category, project, area and date range (the allowed period is up to 30 days from the start date).</li></br><li>With detail: When enabled it shows the information per item, including country, currency, exchange rate, UUID and description of each receipt; when disabled the information is shown grouped.</li></br><li>Download report: Generates the report in XLS format with the results of the search performed.</li>'
    },
    reportstype: {
      title: 'Accumulated expenses by category Page',
      text:
        'It allows to obtain the subtotal and total of the expenses applied by categories, to obtain a more complex panorama of expenses, in the same way if you wish you can apply the filtering based on specific data that you require. (report download applies in XLS format and attachments containing expenses).'
    },
    reportsByConceptPage: {
      title: 'Detailed expenses by category Page',
      text:
        'It allows to obtain the list of expenses by category in detail, showing data in specific expenses, in the same way if you want you can apply filtering based on specific data that you require. (Applies download report in XLS format and attachments containing expenses).'
    },
    annualExpensesReport: {
      title: 'Annual expenses by category Page',
      text: 'It allows you to obtain the total amounts of expenses that were completed, within a year, organized by month and categories. In the same way, if you wish, you can apply filtering based on specific data that you require. (Applies download report in XLS format and attached files containing expenses).'
    },
    annualExpensesByEmployedReport: {
      title: 'Annual expenses by employee Page',
      text: 'It allows to obtain the total amounts per user, represented by month for a year, in the same way if you want you can apply the filtering based on specific data that you require. (Applies download of report in XLS format and attached files that contain expenses). '
    },
    reportComparativePage: {
      title: 'Comparative of expenses Page',
      text:
        'It allows obtaining a comparison of amounts generated with specific filtering offered by the system, either by user, category, or project, taking into account two periods: "Monthly and Quarterly". (Download report in XLS format applies).'
    },
    SatXMLDownloadPage: {
      title: 'Xml pending for download of the SAT Page',
      text:
        'View the list of expenses that your employees have uploaded through the mobile application, using the QR method. To do this, you must install the electron application provided by the bluespend system. The download of the application is available for windows, linux and mac.'
    },
    SettingsPage: {
      title: 'Settings Page',
      text:
        "Enter the period setting to indicate the cutoff date for your company's expenses (essential configuration for the expense flow process)."
    },
    verifyEFOSPage: {
      title: 'Verify EFOS Page',
      text:
        'On this page you will be able to verify all your invoices that are in the blacklist of sat, perform the search using two options: <br/> <br/> <ol> <li> SEARCH BY RFC: Enter any rfc with the purpose of corroborating whether or not it belongs to the black list, this will help you identify them before uploading an expense corresponding to said RFC. </li> <br/> <li> VERIFY CFDIS: Allows you to search for those expenses with rfc that are on the SAT blacklist. (Expenses that were loaded directly into the system for the company). </li> </ol>'
    },
    rolesPage: {
      title: 'Roles Page',
      text:
        'As a SuperAdmin user, you have the option of being able to add additional Roles. As well as adding or removing permissions to the roles, this allows having an extensive management in the system for each role.'
    },
    permissionsPage: {
      title: 'Permissions Page',
      text:
        'It allows displaying the list of permissions established by the system, as well as adding additional permissions to be used.'
    },
    ExpenseItemPage: {
      title: 'Expenses Items Page',
      text:
        'Let upload your expenses in an easy and secure way, you can do it from two forms:<br/><br/><ul><li>CFDI(XML): Are expenses in the form of XML files, validated by the SAT (tax agency of México), the system has the flexibility of letting upload the XMLs in batch, this means you can drag and drop many files, to process them and find out if there are any repeated receipts.</li><li>RECEIPT: These represent the information that is on a printed or digital receipt, to validate them, the fields must be filled manually to process them.</li></ul> <br/> For every expense item loaded you are able to attach optional files or required files (this is defined by your admin). You can differentiate when an expense item requires an attachment as follows: The attach icon (<i aria-hidden="true" class="v-icon material-icons theme--light" style="font-size: 20px;">attach_file</i>) is color <span style="color: blue">BLUE</span> when is optional and is color <span style="color: red">RED</span> when required.'
    },
    attachFilesPage: {
      title: 'Attach Files Page',
      text:
        'Allows you to upload your necessary or required attachments for each expense<br/>The files allowed to upload are in formats:<br/><br/><ul><li>PDF</li><li>JPEG</li><li>ZIP</li></ul>To upload files you can drag and drop, or position yourself in the "upload files" blank space to redirect them to your documents.'
    },
    reportExpenseTrackingPage: {
      title: 'Expenses Tracking Page',
      text:
        'Allows you to obtain the expenses of all your users in different states that are registered in the Bluespend system. <br/><br/> This helps to track each expense and generate filters according to the required queries. Likewise, the download report button allows you to generate an XLS file with the searched data. <br/><br/> The data for the current month will appear in the default table.'
    },
    ConciliationPage: {
      title: 'Amex Conciliations Page',
      text:
        'Allows bank conciliations of Amex expenses to expenses registered in the Bluespend system. <br/> <br/> It has three tabs where you will find the following: <br/> <br/> <ul><li> <b> To concile: </b> <br/> The system detects coincidences of Bluespend expenses automatically, so that you proceed to concile with those expenses that coincide with the amex expense. <br/> <br/> </li> <li> <b> Conciled: </b> <br/> You can view those expenses that have been reconciled (Amex-Bluespend). </li> <br/> <li> <b> Excluded: </b> <br/> Amex and bluespend expenses that have been excluded from searches are shown </li> </ul>'
    },
    ToReconcileExpensesPage: {
      title: 'To Reconcile Page',
      text:
        'On this page you can view the list of amex expenses according to a range of filtered dates. In the expected result there are two types of responses: <br/> <br/> <ul> <li> <span style = "color: red"> <b> NOT FOUND: </b> </span> This result It is due when the system did not find any bluespend expenses with the same amount and within the date range of 1 month maximum. <br/> <br/> </li> <li> <span style = "color: green" > <b> FOUND: </b> </span> When the system finds bluespend expenses matching the amex expense. Based on this result, the user can exclude or reconcile the expense equivalent to amex. <br/> <br/> </li> <li> <b> FILTER: </b> You can filter by specific employees. </li> </ul>'
    },
    ReconciledExpensesPage: {
      title: 'Reconciled Page',
      text:
        'On this page you can obtain the list of expenses that have been reconciled, it has precise information to see the amounts spent on the card, amounts that have been reconciled, missing amounts to reconcile and amounts that have been excluded. <br/> <br/> You can use the filter to search for expenses reconciled by specific employees. (This filter only applies to ADMINISTRATOR users): <br/> <br/> <ul> <li> “Reconciled expenses” filter: It allows showing the list of reconciled expenses. <br/> <br/> <li> Filter "Rejected Expenses" allows to show the list of expenses that are pending to be reconciled. <l / i> </li> </ul>'
    },
    ExcludedExpensesPage: {
      title: 'Excluded Page',
      text:
        'The excluded expenses page allows you to show the list of expenses that were removed from the list to be reconciled, all the expenses that are excluded will not appear again in the search to coincide with a bluespend expense. <br/><br/> You can filter the search by specific users of your company, in this case the system will show data for the only user. '
    },
    MissingExpensesPage: {
      title: 'Missing Page',
      text:
        'The page of rejected expenses allows you to return the list of expenses that have not found matches with bluespend expenses, so it can generate the load of said expense in the bluespend system. <br/> <br/> The option <button type="button" class="v-btn v-btn--icon v-btn--outline v-btn--depressed v-btn--small theme--light info--text"><div class="v-btn__content"><i aria-hidden="true" class="v-icon material-icons theme--light" style="font-size: 16px;">add</i></div></button> <br/> Allows you to upload the expense, be it a fiscal expense or a non-fiscal expense, by clicking it allows you to select the type and later upload the requested file.'
    },
    cashierpage: {
      title: 'Representative Page',
      text: 'To register a representative, you must click on the "Add representative" option. You can register from one to many representatives with the "user" role, these representatives will be in charge of making reservations for other users of the company. </br> A representative can be related to a specific area, or globally to the system.'
    },
    generalSearchPage: {
      title: 'General search page',
      text:
        'This page obtains as a starting point the identification and search of an id or folio in the entire Bluespend system, achieving a better positioning of the data and, in turn, a greater organization. '
    },
    GeneralConfig: {
      title: 'General Settings Page',
      text:
          'In this section you will find all the options needed to configure the bluespend system. Register Areas, Projects, Keywords, etc.'
    },
    viaticRequestPage: {
      title: 'Expense request page',
      text:
          'Generates various expense requests, you can register a request indicating if it is a trip, or if you are going to require a vehicle from your company. Each request is sent and validated by superiors to give approval. When creating a request you will be able to add from one to many categories according to the needs. You must select if the request that is being requested is of type: <br/><br/><ul><li>Petty Cash/AMEX Card: When a box with positive amounts is related to be able to use it in expenses.</ li><li>Advance verification: When you require the company to provide you with an estimated amount of the expenses to arise.</li><li>Reimbursement: Default option provided by the system, when the expenses generated in the request are reimbursed by the company at a certain time.</li></ul><br/> For each request you can see the progress in the tabs UNDER VALIDATION, APPROVED, REJECTED.'
    },
    reservationsPage: {
      title: 'Reservation page by request',
      text:
          'You can create expense requests for those users in your company. These reservations are assigned to users who submit expenses during a given trip. For each request to create you must select if the request that is being requested is of type: <br/><br/><ul><li>Petty Cash/AMEX Card: When a box with positive amounts is related to be able to use it in expenses.</li><li>Advance verification: When you require the company to provide an estimated amount of the expenses to arise.</li><li>Reimbursement: Default option provided by the system, when the expenses that generated in the request are reimbursed by the company at a certain time.</li></ul><br/> For each request you can see the status record. The users responsible for generating requests can charge the expenses generated by the users, in the same way the same user who is assigned the request can do it.'
    },
    reservationsChecksPage: {
      title: 'Check reservation page',
      text:
          'You can generate expense reserves for other users of the company. To register a new verification, you must select the period to which the expenses will apply, the corresponding project, and the user to whom the expense will be assigned. once the reservation is created, the assigned user can upload their expense lines.'
    },
    vehicles: {
      title: 'Vehicle page',
      text:
          'Register the catalog of existing vehicles in the company. The records of said vehicles will serve to be able to relate Request for Expenses with a vehicle. </br> When entering a new vehicle, you must register the type, name, series, model and license plates of the car. In addition to additional information in description.'
    },
    GeneralReports: {
      title: 'Reports Page',
      text:
          'A selection of multiple reports is displayed with an overview. Each report provides different data according to the required needs. </br></br> You can carry out very specific searches for expenses with users in the "Detailed expenses by employee" report, or if you like to keep track of all the expenses issued, you can consult the "Follow-up of checks" report, these to mention the most relevant. </br></br> To see each report, you must click on each of them, which will redirect you to the data table to filter the required data.'
    },
    HelpCenter: {
      title: 'Help Center Page',
      text:
          'Raise the incidences presented in the bluespend system, remember that we are here to help you, and each comment of yours will help us to continue improving. </br></br> To make a report you must click on "REPORT INCIDENCE", from there you will be redirected to the ticket system where you can make the report indicating the details of the incidents.'
    },
    FuelReport: {
      title: 'Fuel report page',
      text:
        'It shows the data of vehicles that have made trips and are related to a request, to know how many kilometers they traveled and the liters of gasoline they consumed.'
    },
    advancesRequest: {
      title: 'Request for advance expenses',
      text: 'Keep track of advance requests and the budget by category of expenses required by users'
    }
  },
  expenseRejected: {
    goRejectedExpenses: 'Go to rejected expenses',
    goChecks: 'Go to Checks',
    addExpensesRejectedMessage:
      'Rejected expense has been added to check, to make the modification you must "Go to Checks" to resend your expense.'
  },
  cashier: {
    name: 'Representative',
    addCashier: 'Add cashier',
    selectionUserCashier: 'Select the cashier user*',
    areaCashier: 'Select an area (optional)',
    delete: 'Delete cashier'
  },
  generalSearch: {
    name: 'General search',
    checkType: 'Check type',
    noResults: 'No related results found',
    request: 'Download request',
    check: 'No. check',
    uuidNumber: 'No. UUID (Data registered in the CFDI)'
  },
  vehicles: {
    vehicles: 'Vehicles',
    type: 'Type',
    name: 'Name',
    description: 'Description',
    serie: 'Serie',
    model: 'Model',
    licensePlate: 'License plate',
    titleAdd: 'Add vehicle',
    titleEdit: 'Edit vehicle',
    titleDelete: 'Delete vehicle',
    save: 'Save',
    cancel: 'Cancel',
    required: 'Is required',
    deleteQuestion: 'Are you sure you want to delete this vehicle?',
    vehicle: 'Vehicle',
    report: {
      name: 'Fuel report',
      description: 'Allows to obtain data of vehicles that have made travel trips and are related to a request, to know how many kilometers they traveled and the liters of gasoline they consumed.',
      application: 'Application',
      vehicle: 'Vehicle',
      licensePlate: 'Plate',
      project: 'Project',
      assignedTo: 'Assigned to',
      dateAssigned: 'Date assigned',
      KmTraveled: 'Km traveled',
      fuel: 'Fuel',
      allVehicles: 'All vehicles',
      perVehicle: 'Per vehicle'
    }
  },
  documentsDownload: {
    title: 'Download documents',
    acknowledgment: 'Acknowledgment',
    expenseRequestPDF: 'Expense Request .pdf',
    expenseRequestXLS: 'Expense Request .xls',
    zipFiles: 'Files .zip'
  },
  vendors: {
    messageNewVendor: 'It will be added as a new supplier, when saving the request.'
  },
  branches: {
    allBranches: 'All Branches',
    selectedMultiple: 'Selected multiple branches',
  },
  representatives: {
    title: 'Representatives',
    representative: 'Representative',
    subtitle: 'Representatives of the company by user',
    add: 'Add representative',
    delete: 'Delete representative',
  },
  request: {
    title: 'Request',
    subtitle: 'Expense request history',
    validate: 'Validate request',
    validatePettyCash: 'Validate petty cash request',
    toValidate: 'To validate',
    toApprove: 'To approve',
    validated: 'Validated',
  },
  config: {
    title: 'Configuration',
    approvalFlows: 'Approval flows',
  },
  support: {
    title: 'Support',
  },
  file: {
    errorViewDownload: 'Use the download button if you cannot view the PDF'
  }
}



// WEBPACK FOOTER //
// ./src/lang/en.js